import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const RelatedStyles = ({ relatedProducts }) => {
  const navigate = useNavigate();
  const { productId: currentId } = useParams();

  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <div className="mt-4">
      <div className="flex items-center mb-5">
        <Sparkles size={18} className="text-[#57030C]" />
        <h3 className="text-lg font-medium text-[#57030C] relative ml-2">
          Colors:
          <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-[#57030C] to-transparent"></span>
        </h3>
      </div>

      <div className="flex gap-3 justify-between overflow-x-auto  scrollbar-hide">
        {relatedProducts.map((product) => (
          <div
            key={product._id}
            className="flex flex-col items-center cursor-pointer"
            onClick={() => navigate(`/product/${product._id}`)}
          >
            <div
              className={`w-20 h-20 rounded-full overflow-hidden border-1 bg-white m-1 
              ${
                product._id === currentId
                  ? 'border-[#57030C] ring-[1px] ring-[#57030C] ring-offset-2 '
                  : 'border-gray-300'
              } 
              shadow transition-all`}
            >
              <img
                src={product.image?.[0]}
                alt={product.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            {product.color && (
              <p className="text-xs text-center text-gray-600 mt-1 capitalize">{product.color}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedStyles;
